import waRequest from './wa-request';

export const baseApi = '/servicenow-integration/v1';

/**
 * Connection Info Controller methods
 */
function getConnectionInfo({params: {snowClientId, snowClientSecret, snowUrl}}) {
  const url = `${baseApi}/connection-info`;

  return waRequest.requestAuthenticated({
    url,
    method: 'GET',
    params: {
      snowClientId,
      snowClientSecret,
      snowUrl,
    },
  });
}

/**
 * Configurations Controller methods
 */
function getOrganizationServicenowConfiguration({pathParams: {organizationId}}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations`;

  return waRequest.requestAuthenticated({url, method: 'GET'});
}

function createOrganizationServicenowConfiguration({
  params: {authorizationCode, includeSubOrganizations, organizationId, snowClientId, snowClientSecret, snowUrl},
}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations`;

  return waRequest.requestAuthenticated({
    url,
    method: 'POST',
    data: {
      authorizationCode,
      includeSubOrganizations,
      snowClientId,
      snowClientSecret,
      snowUrl,
    },
  });
}

function deleteOrganizationServicenowConfiguration({params: {organizationId}}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations`;

  return waRequest.requestAuthenticated({url, method: 'DELETE'});
}

function patchOrganizationServicenowConfiguration({params: {enabled, includeSubOrganizations, organizationId}}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations`;

  return waRequest.requestAuthenticated({
    url,
    method: 'PATCH',
    data: {
      enabled,
      includeSubOrganizations,
    },
  });
}

export default {
  createOrganizationServicenowConfiguration,
  deleteOrganizationServicenowConfiguration,
  getConnectionInfo,
  getOrganizationServicenowConfiguration,
  patchOrganizationServicenowConfiguration,
};
